###
  For the content engine, games should attempt to follow a consistent pattern
  to reduce user (and developer) strain. Score and timer changes, for example,
  are handled in a consistent interface, and games should follow the pattern:

  - initializeData()
  - initializeElements()
  - enterGame()
  - showNext(isFirstRun = true)
  - startGame()
    - checkAnswer()
      if isCorrect
        - endGame()
      else
        - showNext(isFirstRun = false)

  - endGame()
  - afterAnimateScores()

  Games are displayed in "lightbox" mode while the game is in progress.
###

GameView                      = require("views/game")
{ Sound, Session, Analytics } = Application.actions()

system = [
  "system:achievement"
  "system:new-star"
  "system:spin-win"
  "system:correct"
  "system:ready"
  "system:spinning"
  "system:game-music-slow"
  "system:spin-fail"
  "system:tally-score"
  "system:go"
  "system:spin-stop"
  "system:welcome"
  "system:incorrect"
  "system:spin-success"
]

for sound in system
  Sound.preload sound, sound

class EngineGameView extends GameView
  show: ->
    super

    @initializeData()
    @initializeElements()

    Session.get (err, session) =>
      if session.scores?
        scores = session.scores
        name   = @options.name
        record = if scores?[name]? then parseInt(scores[name], 10) else null
        @game.score.set("record", record) if record?

  hide: ->
    super

    Sound.stopAll()

  onRefresh: ->
    super

    Sound.stopAll()

    @trigger("ui", minimal: false) if @game.extra.get("fullscreen")

  initializeData: ->

  initializeElements: ->
    elements = ["timer", "progress-bar", "stepper", "score", "tally", "stars"
                "total", "record", "bonus-time"]

    for key in elements
      selector = ".game-#{key}"
      @setEl @el.querySelector(selector), key

  onTimerChange: (m) ->
    {remaining, count, lastBonus, paused} = m.changed

    if remaining? and @getEl("timer")?
      limit = m.get("limit")
      asSec = (remaining / 1000)
      asSec = (if asSec < 10 then "0" else "") + asSec.toFixed(2) + "s"

      @getEl("timer").innerHTML =
        asSec.replace /^[0s\.]+/, (w) ->
          _.wrapInTag(w, "em", class: "game-timer-muted")

    if remaining? and @getEl("progress-bar")?
      d = @game.timer.get("interval")
      @transform @getEl("progress-bar"),
        x: "#{-remaining / limit * 100}%"

    if count? and @getEl("stepper")?
      @transition @getEl("stepper"), "all 100ms"
      @getEl("stepper").offsetLeft
      @transform @getEl("stepper"), x: "-50%", scale: 0.75

      @el.classList.toggle("game-count-down", count > 0)

      window.setTimeout (=>
        @transition @getEl("stepper"), ""
        @transform @getEl("stepper"), x: "-50%", scale: 1.25

        if count > 0
          @getEl("stepper").style.opacity = 1
          @getEl("stepper").innerHTML = count
          Sound.play "system:ready"
        else
          @getEl("stepper").style.opacity = 0
          @getEl("stepper").innerHTML = i18n("game.go")
      ), 120

    if lastBonus > 0 and @getEl("bonus-time")?
      bonusTime = (lastBonus / 1000).toFixed(2)
      @showBonus
        el: @getEl("bonus-time")
        x: "-2em"
        html: i18n("game.bonus-time", { bonus_time : bonusTime }) or "+#{bonusTime} seconds"
        delay: 400

    if paused? and m.hasLimit()
      @el.classList.toggle("game-paused", paused)

  onScoreChange: (m) ->
    {correct, total, record} = m.changed

    if record? and @getEl("record")?
      @getEl("record").innerHTML = _.prettyNumber(record)
      @getEl("record").offsetLeft

    if total? and @getEl("total")?
      @getEl("total").innerHTML =
      @getEl("score").innerHTML =
        _.prettyNumber(total)

  showBonus: ({el, x, html, delay}) ->
    el.innerHTML = html
    @transform el, {x, transition: "none", opacity: 0}
    el.offsetLeft

    @transition el, "", true

    window.setTimeout (=>
      @transform el, {x: 0, opacity: 1}
    ), 1 + (delay or 0)

    window.setTimeout (=>
      @transform el, {opacity: 0}
    ), 1000 + (delay or 0)

  enterGame: ->
    super

    Sound.stop "system:tally-score"

    @el.classList.add("disable-goto-next")

    @trigger("ui", minimal: true) if @game.extra.get("fullscreen")
    @showNext(true)

  startGame: ->
    Sound.fadeIn "system:game-music-slow" if @game.extra.get("sounds")
    super

  endGame: ->
    try
      answerDetails = @answerDetails?()
    catch err
      console.error "Error on end game", err
      answerDetails = []

    if @game.extra.get("sounds")
      Sound.fadeOut "system:game-music-slow"
      Sound.loop "system:tally-score"

    super

    @trigger("ui", minimal: false) if @game.extra.get("fullscreen")

  afterAnimateScores: ->
    if @game.extra.get("sounds")
      Sound.stop "system:tally-score"
      Sound.play "system:spin-win"

    @el.classList.remove("disable-goto-next")

    if @options.data
      { game, challenge_configuration } = @options.data

    nbStars =
      if challenge_configuration?.nb_stars is 0 
        0
      else
        challenge_configuration?.nb_stars ?
        challenge_configuration?.weighting

    earned = 0
    if !!@game.timer.get("isDisabled") and @game.score.get("incorrect") == 0
      earned = nbStars
    else if game?.stars and nbStars
      {earned} = @calculateStarsEarned
        score: @game.score.get("record")
        stars: nbStars
        range: @options.data.game.stars

    # Process game interaction only if the scores are to be calculated
    if game?.stars
      Session.get (err, { attempt }) =>
        @lesson.processInteraction
          score:           _.clone(@game.score.attributes)
          time:            _.clone(@game.timer.attributes)
          id:              @options.id
          name:            @options.name
          type:            @options.type
          nb_stars_earned: earned
          configuration:   @options.data.challenge_configuration
          game:            true
          slideData:       @options.data
          attempt:         attempt
          answerDetails:   @answerDetails?() or []
          metadata:        @options.metadata

    preposition = i18n('game.of') or 'of'
    @getEl("stars").innerHTML =
      earned + _.wrapInTag(" #{preposition} #{nbStars}", "sup", {class: "stars-total"})

    super

  calculateStarsEarned: ({score, stars, range}) ->
    {min, max} = range

    numLevels = if stars > 1 then stars - 1 else 1
    levels = [0...stars].map (i) -> (max - min) / numLevels * i + min
    level  = _.chain(levels).filter((n) -> score >= n).last().value()
    earned = levels.indexOf(level) + 1

    { earned }

  onCorrectAnswer: ->
    Sound.play "system:correct" if @game.extra.get("sounds")
    super

  onIncorrectAnswer: ->
    Sound.play "system:incorrect" if @game.extra.get("sounds")
    super

  showNext: (isFirstRun) ->

  checkAnswer: ->

  screenshot: ->
    @stopListening()
    @el.classList.remove("game-count-down", "game-paused")
    @setState("playing", "game")
    super arguments...

module.exports = EngineGameView
